import { shape_triangle } from "./drawing-shapes";
import { DrawShapeBaseAdvancedModule } from "../../ModuleBase/shape-base-advanced-module";

export class DrawShapesTriaModule extends DrawShapeBaseAdvancedModule {
	constructor(canvas, getColor, drawingHistory) {
		super(canvas, getColor, drawingHistory);

		this.name = "tria";
		this.icon = shape_triangle;

		this._getInitialShape = pointer => {
			return new fabric.Triangle({
				left: pointer.x,
				top: pointer.y,
				width: 2,
				height: 2,
				fill: this.transpColor,
				strokeWidth: 2,
				stroke: this.__getColor(),
				selectable: false
			});
		};

		this._resizeShape = (e) => {
			const pointer = this.canvas.getPointer(e);
			const diffX = (pointer.x - this.startPosition.x);
			const diffY = (pointer.y - this.startPosition.y);
			let left, top, width = Math.abs(diffX), height = Math.abs(diffY);
			if (diffX >= 0 && diffY >= 0) {
				// left top -> right bottom
				left = this.startPosition.x;
				top = this.startPosition.y;
			} else if (diffX < 0 && diffY < 0) {
				// right bottom -> left top
				left = pointer.x;
				top = pointer.y;
			} else if (diffX < 0) {
				// right top -> left bottom
				left = pointer.x;
				top = this.startPosition.y;
			} else if (diffY < 0) {
				// left bottom -> right top
				left = this.startPosition.x;
				top = pointer.y;
			}
			this.shape.set({ left, top, width, height });
		}
	}
}

window.customElements.define(
	"inspx-draw-shapes-tria-module",
	DrawShapesTriaModule
);
